import { Component, OnInit,Input,ViewEncapsulation } from '@angular/core';
import * as d3 from "d3";

import { ChartOptions, ChartType, ChartDataSets} from 'chart.js';
import { MultiDataSet, Label,PluginServiceGlobalRegistrationAndOptions } from 'ng2-charts';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import * as backInter from 'app/auth/auth-data.model';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import Swal from 'sweetalert2';
import {MatTableDataSource} from '@angular/material/table';
import {TranslateService} from '@ngx-translate/core';
import { MatDialog, MatDialogRef} from '@angular/material/dialog';
import * as catalogoReglas from 'app/main/pagina/tools/gestUsu/auditoria-auto/catalogoReglas';

export interface PeriodicElement {
  nombre: string;
  telefono: string;
  celular: string;
  email: string;
  comentario: string;
}

@Component({
  selector: 'resultados-audi',
  templateUrl: './resultados-audi.component.html',
  styleUrls: ['./resultados-audi.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResultadosAudiComponent implements OnInit {
  displayedColumns: string[] = ['nombre', 'telefono', 'celular', 'email', 'comentario'];
  tablaColaboradores: MatTableDataSource<backInter.muestrasAuditoria>;
url='auditoria/auditoriaAutomatizada/';
////Horizontal Bar
 barChartOptions: ChartOptions;
 barChartLabels: Label[]
 barChartType: ChartType = 'horizontalBar';
 barChartLegend = true;
 barChartData: ChartDataSets[];
 ChartColors:any[];
 barChartPlugins:any;

 ///// Vertical Bar
 barChartOptionsVertical: ChartOptions;
 barChartLabelsVertical: Label[]
 barChartTypeVertical: ChartType = 'bar';
 barChartLegendVertical = true;
 barChartDataVertical: ChartDataSets[];
 ChartColorsVertical:any[];
 muestra:boolean;
 muestras:any;
 consultaGrafica:any[]=[];
 creacionGrafico:boolean=false;
 nombreColaborador:any[]=[];
 tiempoTranscurrido:any;
 muestrSeleccionada:any;
 validarSeleccion:any;
 nombreEmpresa: any;
 nombreProducto: any;



 public pieChartOptions: ChartOptions = {
     responsive: true,
     legend: {
       position: 'top',
     },
     plugins: {
       datalabels: {
         formatter: (value, ctx) => {
           const label = ctx.chart.data.labels[ctx.dataIndex];
           return label;
         },
       },
     }
   };
   public pieChartLabels: Label[] = [['Download', 'Sales'], ['In', 'Store', 'Sales'], 'Mail Sales'];
   public pieChartData: number[] = [300, 500, 100];
   public pieChartType: ChartType = 'pie';
   public pieChartLegend = true;
   public pieChartColors = [
     {
       backgroundColor: ['rgba(255,0,0,0.3)', 'rgba(0,255,0,0.3)', 'rgba(0,0,255,0.3)'],
     },
   ];

  constructor(
    private odsService: ODSService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private transalateAuditoria:TranslateService,
    public dialog: MatDialog,
  ) {
    lang_perfiles.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
    this.getMuestrasColaboradores(1);
    this.graficaVertical();
    console.log(localStorage.getItem('configurationID'));
 this.getConsulta1(1);
 this.nombreEmpresa= localStorage.getItem('CompanyName');
 this.nombreProducto= localStorage.getItem('ProductName');

  }

  // getConsulta1(){
  // var horaInicio,horaFin;
  // this.odsService.getAuditoriaMenor10Min(localStorage.getItem('configurationID')).subscribe((res:any) =>{
  // console.log(res);
  // res.resultado.forEach(element => {
  //   horaInicio=new Date(element.start_date);
  //   horaFin = new Date(element.end_date);
  //   this.tiempoTranscurrido = ((horaFin-horaInicio)/(1000*60));
  //   this.consultaGrafica.push(this.tiempoTranscurrido);
  //   this.nombreColaborador.push(element.name);
  //   // console.log(this.tiempoTranscurrido);
  // });
  // this.consultaGrafica.push(0);
  // this.graficaHorizontal(this.consultaGrafica,this.nombreColaborador);
  //
  //   });
  // }

  crearMuestrasMenor10Min(){
    let mensaje: string;
    let boton:string;
    this.transalateAuditoria.get('RESULTA-AUDITO.MODALES.TITULO').subscribe((res: string) => { mensaje = res; });
    this.transalateAuditoria.get('RESULTA-AUDITO.MODALES.CERRAR').subscribe((res: string) => { boton = res; });

 Swal.fire({
 title: 'ingresa el nombre de la muestra ',
 input: 'text',
 inputAttributes: {
  autocapitalize: 'off'
 },
 showCancelButton: true,
reverseButtons: true,
 confirmButtonText: 'aceptar',
 showLoaderOnConfirm: true,

 allowOutsideClick: () => !Swal.isLoading()
 }).then((result) => {
 if (result.value) {
 let data:any = {nombre: result.value}
 console.log(data);

  this.modalCargaMuestra();
  this.odsService.crearMuestraMenor10Min(localStorage.getItem('configurationID'),localStorage.getItem('productoID'),data).subscribe((respuesta:backInter.respuestaAgregarUsuariosAuditoria) => {
    console.log(respuesta);
    if(respuesta.success==true){
      Swal.close();
      Swal.fire({
       title: 'se agrego' + result.value
     })
     }
     else{
       if(respuesta.message=="sinUsuarios"){
       Swal.close();
       Swal.fire({
        icon: 'warning',
        title: 'Ya no quedan usuarios para registrar',
        showConfirmButton: true,
        confirmButtonText: boton
       })
       }
     }
    // this.resultadoConteo = respuesta;
    this.getMuestrasColaboradores(1);
  }, error => {
    console.log(error);
  });

 }
 })






  }

  getMuestrasColaboradores(muestrSeleccionada:any){
    this.odsService.getMuestraMenor10Min(localStorage.getItem('productoID')).subscribe((res:backInter.Muestras) =>{
console.log(res);
if(res.muestras.length>0){
  this.muestras=res.muestras;
  this.muestra=true;
}else{
  this.muestra=false;
}
console.log(this.muestra);

res.muestras.forEach(element => {
  if(element._id==muestrSeleccionada){
    this.tablaColaboradores = new MatTableDataSource(res.muestras);
  }
});
    });
  }

graficaHorizontal(datos:any, nombreColaborador:any){
  this.barChartOptions = {
    responsive: true,
    legend: {
 display: false,
   },
    scales: {
      xAxes: [{
      ticks: {
      fontStyle:"bold",
      fontColor: "black",
            }}],
      yAxes: [{
        ticks: {
        fontStyle:"bold",
        fontColor: "black",
              }
      }] },
    plugins: {

      datalabels: {
        anchor: 'end',
        align: 'end',
      }

    },
  };
  this.barChartPlugins = [pluginDataLabels];

  this.barChartData= [
    { data: datos, label: 'Tiempo de respuesta en minutos',

    }
   //  { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B',
   // }
  ];
  this.barChartLabels= nombreColaborador;

  this.ChartColors = [
    {
      backgroundColor: ['#e40601', '#e40601', '#e40601','#e40601','#e40601', '#e40601','#e40601']
    }
    // {
    //
    //   backgroundColor: ['#703903', '#703903', '#703903','#703903','#703903', '#703903','#703903'],
    // },
  ];
  this.creacionGrafico=true;
}

graficaVertical(){
  this.barChartOptionsVertical = {
    responsive: true,
    legend: {
 display: false,
   },
    // We use these empty structures as placeholders for dynamic theming.
    scales: { xAxes: [{}], yAxes: [{}] },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }

    },
  };

  this.barChartDataVertical= [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
    { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' }
  ];
  this.barChartLabelsVertical= ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  this.ChartColorsVertical = [
    {
      backgroundColor: ['#D56217', '#D56217', '#D56217','#D56217','#D56217', '#D56217','#D56217'],
    },
    {
      backgroundColor: ['#703903', '#703903', '#703903','#703903','#703903', '#703903','#703903'],
    },
  ];
}

editarComentarioAuditoria(idColaborador:any, comentarioAU:string, event){
  let mensaje: string;
  let boton:string;
  let mensajeInfo:string;
  this.transalateAuditoria.get('RESULTA-AUDITO.MODALES.TITULO').subscribe((res: string) => { mensaje = res; });
  this.transalateAuditoria.get('RESULTA-AUDITO.MODALES.CERRAR').subscribe((res: string) => { boton = res; });
  this.transalateAuditoria.get('RESULTA-AUDITO.MODALES.TITULO_INFORMACION').subscribe((res: string) => { mensajeInfo = res; });

  if(event.target.value.length >= 1){
  let datos={
    comentario:comentarioAU
  }
  this.modalCarga();
  this.odsService.editarComentarioAuditoria(idColaborador,datos).subscribe((res:backInter.comentarioAuditoria) =>{
  console.log(res);
  if(res.message=="200"){
    Swal.close();
    Swal.fire({
     icon: 'success',
     title: mensaje,
     showConfirmButton: true,
     confirmButtonText: boton
    })
  }
  }, error => {
    console.log(error);
  });
}
else{
  Swal.fire({
   icon: 'info',
   title: mensajeInfo,
   showConfirmButton: true,
   confirmButtonText: boton
  })
}
}

modalCargaMuestra(){
  let mensaje: string;
  this.transalateAuditoria.get('RESULTA-AUDITO.MODALES.GENERANDO').subscribe((res: string) => { mensaje = res; });

  Swal.fire({
    title: mensaje,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading()
    }
  });
}

modalCarga(){
  let mensaje: string;
  this.transalateAuditoria.get('RESULTA-AUDITO.MODALES.GUARDANDO').subscribe((res: string) => { mensaje = res; });

  Swal.fire({
    title: mensaje,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading()
    }
  });
}

getConsulta1(muestrSeleccionada:any) {
  this.consultaGrafica=[];
  this.nombreColaborador=[];
  var horaInicio,horaFin;
  this.odsService.getMuestraMenor10Min(localStorage.getItem('productoID')).subscribe((res:backInter.Muestras) =>{
  console.log(res);
  res.muestras.forEach(colaboradores => {
    if(colaboradores._id==muestrSeleccionada){
    colaboradores.colaboradores.forEach(element => {
    horaInicio=new Date(element.start_date);
    horaFin = new Date(element.end_date);
    this.tiempoTranscurrido = ((horaFin-horaInicio)/(1000*60));
    this.consultaGrafica.push(this.tiempoTranscurrido.toFixed(2));
    this.nombreColaborador.push(element.fullName);
    // console.log(this.tiempoTranscurrido);
    })
    this.validarSeleccion=true;
  }
  });
  if(this.validarSeleccion==true){
  this.consultaGrafica.push(0);
  this.graficaHorizontal(this.consultaGrafica,this.nombreColaborador);
  }
  else{
    console.log("Aun no hay id");
  }

    });
}

openCrearMuestra() {

const dialogRef = this.dialog.open(DialogCrearMuestra,{
height: '55%',
width: '40%',
});
dialogRef.afterClosed().subscribe(result => {
console.log(`Dialog result: ${result}`);
this.getMuestrasColaboradores(1);

});
}




}



  @Component({
    selector: 'modalCrearMuestra',
    templateUrl: 'modalCreaMuestra.component.html',
    styleUrls: ['./modalCrearMuestra.component.scss'],
  })

  export class DialogCrearMuestra {

    reglas=catalogoReglas.reglas;

  nombre=" ";
  selected:any[]=[];

    constructor(
      public dialogActualizar: MatDialogRef<DialogCrearMuestra>,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      private translateSrv: TranslateService,
      private odsService: ODSService,
    ){

    }

    ngOnInit() {
      console.log(this.reglas);



    }

guardaMuestra(nombre:string, valores:any){
  this.selected=valores;
  console.log(nombre);
  console.log(valores);
  if (nombre==' ' && this.selected.length==0 || nombre!=' ' && valores.length==0 || nombre==' ' && valores.length!=0 ) {
    // alert("No olvides colocar un nombre y selecccionar almenos una regla")
    let warningCondicion:string;
    let boton1:string;
    this.translateSrv.get('RESULTA-AUDITO.MODALES.WARNI-CONDI').subscribe((res: string) => { warningCondicion = res; });
    this.translateSrv.get('RESULTA-AUDITO.MODALES.CERRAR').subscribe((res: string) => { boton1 = res; });


    Swal.fire({
     icon: 'warning',
     title: warningCondicion,
     showConfirmButton: true,
     confirmButtonText: boton1
    })
  }else{
      let mensaje: string;
      let mensajeSuccess: string;
      let mensajeSinUsuarios: string;
      let boton:string;
      this.translateSrv.get('RESULTA-AUDITO.MODALES.TITULO').subscribe((res: string) => { mensaje = res; });
      this.translateSrv.get('RESULTA-AUDITO.MODALES.SUCCE-MUES').subscribe((res: string) => { mensajeSuccess = res; });
      this.translateSrv.get('RESULTA-AUDITO.MODALES.WARNI-SINU').subscribe((res: string) => { mensajeSinUsuarios = res; });
      this.translateSrv.get('RESULTA-AUDITO.MODALES.CERRAR').subscribe((res: string) => { boton = res; });
  let data:any = {nombre: nombre,reglas:this.selected,token:localStorage.getItem('tokenConfig')}
     console.log(data);

    this.modalCargaMuestra();
    this.odsService.crearMuestraMenor10Min(localStorage.getItem('configurationID'),localStorage.getItem('productoID'),data).subscribe((respuesta:backInter.respuestaAgregarUsuariosAuditoria) => {
      console.log(respuesta);
      if(respuesta.success==true){
        this.onClose();
        Swal.fire({
         title: mensajeSuccess + nombre
       })
       }
       else{
         if(respuesta.message=="sinUsuarios"){
        this.onClose();
         Swal.fire({
          icon: 'warning',
          title: mensajeSinUsuarios,
          showConfirmButton: true,
          confirmButtonText: boton
         })
         }
       }
      // // this.resultadoConteo = respuesta;
    }, error => {
      console.log(error);
    });



  }


}


modalCargaMuestra(){
  let mensaje: string;
  this.translateSrv.get('RESULTA-AUDITO.MODALES.GENERANDO').subscribe((res: string) => { mensaje = res; });

  Swal.fire({
    title: mensaje,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading()
    }
  });
}

    onClose(): void {
        this.dialogActualizar.close();
      }

  }
